
import Vue from 'vue';
import { mergeData } from 'vue-functional-data-merge';

export default Vue.extend({
  name: 'ButtonStencil',
  functional: true,
  render(h, { data }) {
    return h(
      'div',
      mergeData(data, {
        staticClass: 'button-stencil',
      }),
      [
        h('div', { staticClass: 'button-stencil__container' }, [
          h('div', { staticClass: 'stencil-element' }),
        ]),
      ]
    );
  },
});
